import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class WisconsinLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Wisconsin" />
        <LocationMicroNav />

        { /* Wisconsin, Story 1 */ }
        <LocationContent 
          category="PlacesForBikes" 
          title="The First of Many"
          story="At the first annual PlacesForBikes Conference in Madison, 275 leaders and thinkers gathered to focus on the challenges and opportunities of building better bicycle infrastructure—fast. The conference centered on our four-part formula for building better PlacesForBikes: Engage, Plan, Build and Measure. City leaders from coast to coast networked, shared best practices and developed strong bonds. Trek provides lead sponsorship support for the PlacesForBikes program."
        />  
        <Img
          title="Wisconsin 1-1"
          alt="First Annual PlacesForBikes Conference Photo"
          sizes= { this.props.data.wisconsinOneOneImage.sizes }
        />   

        { /* Wisconsin, Story 2 */ }
        <LocationContent 
          category="Promoting Ridership" 
          title="Goodbye, old friend"
          story='In February, one of the founders of PeopleForBikes, Chris Kegel, passed away. Our senior staff attended a series of celebrations of his remarkable life, which included a group ride in Milwaukee that attracted more than 1,000 of his friends and family. Chris turned a single bike shop, Wheel & Sprocket, into one of the most successful family-owned bike store networks in the U.S. He was a tireless advocate who wanted everyone to experience the joy of a safe bike ride. According to PeopleForBikes president Tim Blumenthal, "Chris had a remarkable ability to see through complicated situations and to blend business and advocacy." PeopleForBikes is helping administer the Chris Kegel Foundation that is dedicated to improving lives through cycling.'
        />  
        <Img
          title="Wisconsin 2-1"
          alt="Chris Kegel"
          sizes= { this.props.data.wisconsinTwoOneImage.sizes }
        />   
      
        <LocationRelated 
          prevLocationName="Washington, DC"
          prevLocationPath="washington-dc"
          prevLocationImgPath= { this.props.data.wisconsinPrevImage }
          nextLocationName="Port Angeles, WA"
          nextLocationPath="port-angeles"
          nextLocationImgPath= { this.props.data.wisconsinNextImage }
        /> 
      </div>
    )
  }
}

export default WisconsinLocation

// GraphQL query
export const wisconsinImageQuery = graphql`
  query wisconsinImageQuery {
    wisconsinOneOneImage: imageSharp(id: { regex: "/PFB_Wisconsin_1-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    wisconsinTwoOneImage: imageSharp(id: { regex: "/PFB_Wisconsin_2-1/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    wisconsinPrevImage: imageSharp(id: { regex: "/PFB_WASHINGTONDC/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    wisconsinNextImage: imageSharp(id: { regex: "/PFB_PORTANGELES/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/wisconsin.js